import ConfigNode from 'Model/ConfigNode'
import ConfigQuery from 'Model/ConfigQuery'

class AppView extends ConfigNode
  @className = 'AppView'

  constructor: (id) ->
    super(id)

  @list = (params = {}) ->
    query = new ConfigQuery()
      .type(@)
      .limit(params.limit or 1000)
      .skip(params.skip or 0)

    unless params.authenticated
      query.equalTo('isPublic', true)

    query.find(@)

  isPublic: ->
    @get('isPublic')

  setPublic: (isPublic) ->
    @set('isPublic', isPublic)

export default AppView
